// ajax-collection.js — Shopify collection AJAX navigation (updated)
// Keeps HTML fragment behavior and ALSO silently fetches + normalizes JSON into window._ptJson
(function() {
  if (!window.fetch) return;

  const SELECTOR_TILE = '.ajax-tile';
  const SELECTOR_GRID = '#CollectionLoop';   // Your theme's main product grid
  const FIL_SELECTOR = '#filter-groups';
  const WRAPPER = '#Collection-Ajax-Wrapper';// Optional wrapper that includes count + grid
  const BODY_LOADING_CLASS = 'ajax-loading';
  const FALLBACK_IMAGE = '/mnt/data/ff6b8459-984a-42d3-b0ee-af4386e43081.png'; // uploaded asset fallback

  // --- Utility: Parse HTML string into a document ---
  function parseHTML(text) {
    const parser = new DOMParser();
    return parser.parseFromString(text, 'text/html');
  }
 
  function scrollDivToTop(selector, offset = 0) {
    const el = document.querySelector(selector);
    if (!el) return;

    const y =
      el.getBoundingClientRect().top +
      window.pageYOffset -
      offset;

    window.scrollTo({
      top: y,
      behavior: 'smooth'
    });
    // Remove 'open' from overlay div
      const overlay = document.querySelector('.loc-overlay.open');
      if (overlay) {
        overlay.classList.remove('open');
      }
  }

  // --- Utility: safe text escape ---
  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  }

  // Resolve an href to a path+query to keep consistent behavior
  function resolveHrefToPath(href) {
    try {
      const u = new URL(href, window.location.origin);
      return u.pathname + u.search + u.hash;
    } catch (e) {
      return href;
    }
  }

  // extract collection handle from path like /de/collections/handle or /collections/handle
  function extractCollectionHandle(path) {
    try {
      const u = new URL(path, window.location.origin);
      const parts = u.pathname.split('/').filter(Boolean);
      const idx = parts.indexOf('collections');
      if (idx >= 0 && parts.length > idx + 1) return parts[idx + 1];
    } catch (e) {
      const m = path.match(/\/collections\/([^\/?#]+)/);
      if (m) return decodeURIComponent(m[1]);
    }
    return null;
  }

  // --- Utility: fetch HTML fragment (existing behavior) ---
  async function fetchFragment(url) {
    const ajaxUrl = url + (url.includes('?') ? '&view=ajax-nohf' : '?view=ajax-nohf');
    const res = await fetch(ajaxUrl, {
      credentials: 'same-origin',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      redirect: 'follow'
    });
    if (!res.ok) throw new Error('Fetch error: ' + res.status);
    const txt = await res.text();
    return parseHTML(txt);
  }

  // -----------------------------------------------------------------------
  // NEW: JSON fetch + normalization (silent / non-blocking)
  // - Attempts to fetch view=ajax&json=1
  // - Normalizes to:
  //   { fetched_at, source_url, collection: { id, title, handle, products_count, ... }, products: [{id,handle,title,price,image,url,variants:[]}, ...] }
  // - Stores on window._ptJson and dispatches event 'ajax:products-json'
  // -----------------------------------------------------------------------
  async function fetchAndNormalizeJson(url) {
    try {
      const jsonUrl = url + (url.includes('?') ? '&' : '?') + 'view=ajax-nohf&json=1';
      const r = await fetch(jsonUrl, {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' },
        redirect: 'follow'
      });

      const ct = (r.headers.get('content-type') || '').toLowerCase();
      if (!r.ok || !ct.includes('application/json')) {
        // not JSON or not ok -> try fallback behavior below (do not throw)
        // console.debug('No JSON from', jsonUrl, 'status', r.status, 'ct', ct);
        return null;
      }

      const data = await r.json();

      // Normalization function for a single product object (Shopify-ish)
      function normalizeProduct(p) {
        // Some servers return product shape directly, others nested. Defensive lookups.
        const id = (p.id !== undefined) ? p.id : (p.product_id !== undefined ? p.product_id : null);
        const handle = p.handle || (p.url && (p.url.split('/').pop())) || null;
        const title = p.title || p.name || '';
        const url = p.url || (handle ? `/products/${handle}` : null) || null;

        // pick first image src if available
        let image = null;
        if (p.images && p.images.length) {
          const img0 = p.images[0];
          image = img0 && (img0.src || img0.url || img0);
        } else if (p.image && (p.image.src || p.image.src)) {
          image = p.image.src || p.image;
        } else if (p.featured_image) {
          image = (p.featured_image.src || p.featured_image) || null;
        }
        if (!image) image = FALLBACK_IMAGE;

        // price normalization
        // Shopify product may have variants; prefer min_price or first variant price
        let price = null;
        if (p.price !== undefined) price = p.price;
        else if (p.variants && p.variants.length) {
          const v0 = p.variants[0];
          price = v0 && (v0.price || v0.price_amount || v0.presentment_price || null);
        } else if (p.price_min !== undefined) price = p.price_min;
        // keep as-is if string or number
        // variants normalized shallow
        const variants = (p.variants && Array.isArray(p.variants)) ? p.variants.map(v => ({
          id: v.id || v.variant_id || null,
          sku: v.sku || null,
          title: v.title || v.name || null,
          price: v.price || v.price_amount || null
        })) : [];

        return {
          id, handle, title, url, image, price, variants
        };
      }

      // Build normalized pt object
      const pt = {
        fetched_at: new Date().toISOString(),
        source_url: url,
        collection: null,
        products: []
      };

      // If server returned productsHtml only (server-rendered), keep raw and try to extract meta
      if (data.productsHtml || data.products_html || data.productsHtml === '') {
        // keep raw in case consumer wants markup
        pt.raw = data;
        // try to grab collection meta if present
        pt.collection = {
          id: (data.collection && data.collection.id) || null,
          title: (data.title || (data.collection && data.collection.title)) || null,
          handle: (data.collection && data.collection.handle) || extractCollectionHandle(url) || null,
          products_count: (data.count || (data.collection && data.collection.products_count)) || null
        };
      } else if (Array.isArray(data.products)) {
        // standard products array
        pt.raw = data;
        pt.collection = {
          id: (data.collection && data.collection.id) || null,
          title: (data.collection && data.collection.title) || null,
          handle: (data.collection && data.collection.handle) || extractCollectionHandle(url) || null,
          products_count: data.products.length
        };
        pt.products = data.products.map(normalizeProduct);
      } else if (data.collection && data.collection.products_count && data.collection && data.collection.handle) {
        // server returned collection info only - try to fetch products.json fallback
        pt.raw = data;
        pt.collection = {
          id: data.collection.id || null,
          title: data.collection.title || null,
          handle: data.collection.handle || extractCollectionHandle(url) || null,
          products_count: data.collection.products_count || null
        };
        // attempt to fetch products.json for that handle (best-effort)
        const handle = pt.collection.handle;
        if (handle) {
          try {
            const prodUrl = `${window.location.origin}/en-gb/collections/${encodeURIComponent(handle)}/products.json?limit=250`;
            //const prodUrl = `${window.location}/products.json?limit=250`;
            const pr = await fetch(prodUrl, { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }});
            if (pr.ok) {
              const pj = await pr.json();

                const isMobile = window.innerWidth <= 768;

                window.ga4Products = pj;
                window.ga4Collection = pt.collection;

              loadProductList(pj, pt.collection, 0, 8);
              if (!isMobile) {
                  setTimeout(() => {
                    loadProductList(
                      window.ga4Products,
                      window.ga4Collection,
                      8,
                      8
                    );
                }, 150);
              }
              
              const arr = (pj && pj.products) ? pj.products : (Array.isArray(pj) ? pj : []);
              if (Array.isArray(arr) && arr.length) {
                pt.products = arr.map(normalizeProduct);
                pt.collection.products_count = pt.products.length;
              }
            }
          } catch (e) {
            // fallback silently
          }
        }
      } else {
        // unknown shape — keep raw and try to pick products if present anywhere
        pt.raw = data;
        if (data.products && Array.isArray(data.products)) pt.products = data.products.map(normalizeProduct);
        else {
          // if vendor returned single product or something else, try best-effort
          // no-op further
        }
      }

      // assign globally & dispatch event
      window._ptJson = pt;
      try {
        document.dispatchEvent(new CustomEvent('ajax:products-json', { detail: pt }));
      } catch (e) { /* ignore */ }

      // return pt for further internal use if caller awaits
      return pt;
    } catch (err) {
      // silent failure; do not break HTML flow
      // console.warn('Silent products JSON fetch/normalize failed', err);
      return null;
    }
  }
  // -----------------------------------------------------------------------

  // --- Update visible collection header/count from fetched doc ---
  function updateCollectionHeaderFromDoc(doc) {
    try {
      // Prefer structured meta
      var meta = doc.querySelector('#ajax-collection-meta');
      var newTitle = null;
      var newCount = null;

      if (meta && meta.dataset) {
        newTitle = (meta.dataset.title !== undefined) ? meta.dataset.title : null;
        newCount = (meta.dataset.count !== undefined) ? meta.dataset.count : null;
      }

      // Fallback to visible .collection-count inside the fragment
      if ((!newTitle || newTitle === 'null') && doc.querySelector('.collection-count')) {
        var vis = doc.querySelector('.collection-count').textContent.trim();
        var m = vis.match(/^(.*)\s*\((\d+)\)\s*$/);
        if (m) { newTitle = m[1].trim(); newCount = m[2]; }
        else { newTitle = vis; }
      }

      // Apply updates to current page elements
      var countElem = document.querySelector('#collection-count');
      if (countElem) {
        if (newTitle && newCount != null) {
          countElem.textContent = newTitle + ' (' + newCount + ')';
        } else if (newTitle) {
          countElem.textContent = newTitle;
        } else if (newCount != null) {
          countElem.textContent = '(' + newCount + ')';
        }
      }

      // Optional: update hero/title if present
      var heading = document.querySelector('.collection-hero__title') || document.querySelector('.page-title');
      if (heading && newTitle) heading.textContent = newTitle;

      // optional numeric-only counter
      var numElem = document.querySelector('#collection-count-number');
      if (numElem && newCount != null) numElem.textContent = newCount;
    } catch (err) {
      console.warn('Could not update collection header from AJAX fragment', err);
    }
  }

  // --- Replace the current product grid or wrapper with the new one ---
  function replaceGrid(doc) {
    // 1) Prefer replacing a wrapper if provided (keeps count + grid in one go)
    var newWrapper = doc.querySelector(WRAPPER);
    if (newWrapper) {
      var curWrapper = document.querySelector(WRAPPER);
      if (curWrapper) {
        curWrapper.replaceWith(newWrapper);
        console.log('✅ Replaced Collection-Ajax-Wrapper');
      } else {
        // if no wrapper on page, insert the wrapper at top of grid area or body
        var curGrid = document.querySelector(SELECTOR_GRID);
        if (curGrid && curGrid.parentNode) {
          curGrid.parentNode.insertBefore(newWrapper, curGrid);
        } else {
          document.body.insertAdjacentElement('beforeend', newWrapper);
        }
        console.log('✅ Inserted Collection-Ajax-Wrapper');
      }
      bindPagination();
      return;
    }

    // 2) Fallback: replace the product grid only
    const newGrid = doc.querySelector(SELECTOR_GRID);
    const newFil = doc.querySelector(FIL_SELECTOR);
    if (!newGrid) throw new Error('Missing ' + SELECTOR_GRID + ' in response');

    const cur = document.querySelector(SELECTOR_GRID);
    const curFil = document.querySelector(FIL_SELECTOR);
    var active_tab_text = document.querySelector('.plp-custom-allvariatns .plp-categories .tiles-row .tile-item.active .tile-title').getAttribute("data-tile-heading").trim();
    var dyn = document.querySelector('.plp-dynamic-title');
    if (dyn && active_tab_text) dyn.innerHTML = active_tab_text;
    
    if (cur) {
      curFil.replaceWith(newFil);
      cur.replaceWith(newGrid);
      
      console.log('✅ Grid replaced successfully');
      window.reindexVisibleProducts();
      window.applyInitialVisibility();
      window.applyViewMoreState();
      document.addEventListener('click', function (e) {

        if (e.target.matches('[data-collection-sidebar-close]')) {
          console.log('Closing sidebar');
          document
            .querySelector('.collection__sidebar__slide-out')
            .classList.remove('expanded'); // replace with your class
        }
      });
      // resetFilters();
    } else {
      document.body.insertAdjacentElement('beforeend', newGrid);
    }

    try {
      // Remove 'open' from overlay div
      const overlay = document.querySelector('.loc-overlay.open');
      if (overlay) {
        overlay.classList.remove('open');
      }
      const yOffset = -500;
      const y = newGrid.getBoundingClientRect().top + window.pageYOffset + yOffset;
      scrollDivToTop('.collection.collection-products.plp-collection-prod',20);
      // FIX: remove body scroll lock
      document.body.style.overflow = '';
      document.body.classList.remove(
        'overflow-hidden',
        'no-scroll',
        'js-drawer-open',
        'filters-open'
      );
    } catch (e) {}

    bindPagination();
  }

  // --- Core loader (global) ---
  window.loadUrl = async function(url, push = true) {
    try {
      document.body.classList.add(BODY_LOADING_CLASS);
      document.dispatchEvent(new Event('ajax:start'));
      console.log('🔄 Loading:', url);

      if (push) {
        history.pushState({ ajaxUrl: url }, '', url);
      }

      // Fire-and-forget: JSON fetch/normalize in parallel (will set window._ptJson & dispatch event)
      fetchAndNormalizeJson(url).catch(()=>{/*ignore*/});

      // Existing HTML fragment behavior (unchanged)
      const doc = await fetchFragment(url);

      // 1) Update header from fetched fragment (meta or visible)
      updateCollectionHeaderFromDoc(doc);

      // 2) Replace wrapper or grid
      replaceGrid(doc);
      document.dispatchEvent(new Event('ajax:end'));
    } catch (e) {
      console.error('❌ AJAX load failed for', url, e);
      // Stay on page — do not redirect
    } finally {
      document.body.classList.remove(BODY_LOADING_CLASS);
    }
  };

  // --- Back / Forward button ---
  window.addEventListener('popstate', function () {
    window.loadUrl(window.location.href, false);
  });

  // --- Tile click (collection tile navigation) ---
  function onTileClick(e) {
    
    const tile = e.target.closest(SELECTOR_TILE);
    if (!tile) return; // not a tile click

    if (e.metaKey || e.ctrlKey || e.shiftKey) return;

    let anchor = (tile.tagName === 'A') ? tile : (tile.querySelector('a.product-link, a') || null);
    if (!anchor) anchor = e.target.closest('a');
    if (!anchor) return;

    let rawHref = anchor.getAttribute('href') || (anchor.dataset && (anchor.dataset.href || anchor.dataset.productLink)) || '';
    if (!rawHref) {
      const miss = anchor.getAttribute('data-product-linssk') || anchor.getAttribute('data-productlink') || anchor.getAttribute('data-product-link');
      if (miss) rawHref = miss;
    }

    if (!rawHref) {
      console.warn('AJAX tile anchor has no href/data-product-link:', anchor);
      return;
    }

    const pathOnly = (typeof resolveHrefToPath === 'function') ? resolveHrefToPath(rawHref) : rawHref;
    if (!pathOnly) {
      console.warn('Could not resolve href for AJAX tile:', rawHref, anchor);
      return;
    }

    e.preventDefault();

    // UI feedback
    var tabLabel = anchor.getAttribute('aria-label') || anchor.textContent || '';
    var countElem = document.querySelector('#collection-count');
    if (countElem && tabLabel) {
      var short = tabLabel.replace(/^Show\s+/i,'').trim();
      countElem.textContent = short + ' (' + '…' + ')';
    }

    // Remove `is-active` class from all sort list items
    document.querySelectorAll('#sort-list li.is-active').forEach(li => {
      li.classList.remove('is-active');
    });

    // Update the sort toggle text
    const toggle = document.querySelector('.popout__toggle');
    if (toggle) {
      // Get text from the first span inside the toggle
      const firstSpan = toggle.querySelector('span');
      const firstText = firstSpan ? firstSpan.textContent.trim() : null;

      // Find the span that should display the sort text
      const sortToggleText = toggle.querySelector('[data-sort-button-text]');
      if (sortToggleText) {
        sortToggleText.textContent = firstText || 'order by';
      }
    }

    // Load actual subcollection (Shopify will filter correctly)
    window.loadUrl(pathOnly, true);

    // ✅ Reset filters ONLY if filters are active
    setTimeout(() => {
      if (hasActiveFilters()) {
        resetFiltersForCollection(pathOnly);
      }
    }, 1000);

    // After URL changes, reload filters & products grid
    fetch(pathOnly).then(res => res.text()).then(html => {
      const doc = new DOMParser().parseFromString(html, 'text/html');

      // Update products grid
      const newProductsGrid = doc.querySelector('[data-products-grid]');
      if (newProductsGrid && this.productsContainer) {
        this.productsContainer.innerHTML = newProductsGrid.innerHTML;
      }

      // Update filter sidebar
      const newSidebar = doc.querySelector('[data-collection-sidebar]');
      if (newSidebar && this.sidebar) {
        this.sidebar.innerHTML = newSidebar.innerHTML;

        // Optional: trigger custom event so filter JS can re-init if needed
        this.sidebar.dispatchEvent(new CustomEvent('theme:filter:update', { bubbles: true }));
      }
    });
  }

  function fixAnchorsAfterInsert(root) {
    if (!root) return;
    root.querySelectorAll('a').forEach(function(a){
      const miss = a.getAttribute('data-product-linssk');
      if (miss) {
        try {
          a.setAttribute('data-product-link', miss);
          a.removeAttribute('data-product-linssk');
        } catch(e){}
      }
      const dp = a.getAttribute('data-product-link');
      if (dp) {
        const cleaned = dp.replace(/\/\/+/g, '/');
        a.setAttribute('data-product-link', cleaned);
        if (!a.getAttribute('href')) a.setAttribute('href', cleaned);
      }
    });
  }

  // --- Pagination click (Next/Prev AJAX pages) ---
  function onPageLinkClick(e) {
    const a = e.target.closest('a.ajax-page');
    if (!a) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();

    var countElem = document.querySelector('#collection-count');
    if (countElem) countElem.textContent = '…';

    window.loadUrl(a.href);
  }

  function bindTiles() {
    document.removeEventListener('click', onTileClick);
    document.addEventListener('click', onTileClick);
  }

  function bindPagination() {
    document.querySelectorAll('a.ajax-page').forEach((a) => {
      a.removeEventListener('click', onPageLinkClick);
      a.addEventListener('click', onPageLinkClick);
    });
  }

  // --- Init ---
  document.addEventListener('DOMContentLoaded', function () {
    bindTiles();
    bindPagination();
    window._ajaxCollectionLoaded = true;

    //console.log('✅ AJAX Collection ready (wrapper-aware + pt JSON producer)');

    // Save initial page state so back button can return to it
    history.replaceState({ ajaxUrl: window.location.href }, '', window.location.href);

    // fetchAndNormalizeJson(window.location.href)
    //   .then((pt) => console.log('📦 Initial PT JSON loaded:', pt))
    //   .catch(() => {});
  });

})(); // IIFE end


// --- Consumer example (optional) ---
// You can place this where you want to react to new pt JSON:
// document.addEventListener('ajax:products-json', (e) => {
//   console.log('PT JSON available:', e.detail);
//   // e.detail.products => normalized product list
//   // e.detail.collection => collection info
// });


window.__ga4SentCount = window.__ga4SentCount || 0;

const loadProductList = (
  products,
  collection,
  startIndex = 0,
  batchSize = 8
) => {
  const productList = products?.products || [];

  const visibleProducts = productList.slice(
    startIndex,
    startIndex + batchSize
  );

  if (!visibleProducts.length) return;

  const items = visibleProducts.map((product, i) => {
    const firstVariant = product?.variants?.[0];

    const price = firstVariant?.price ? parseFloat(firstVariant.price) : 0;
    const compareAtPrice = firstVariant?.compare_at_price
      ? parseFloat(firstVariant.compare_at_price)
      : 0;

    const discount =
      compareAtPrice > price && compareAtPrice > 0
        ? Math.round(((compareAtPrice - price) / compareAtPrice) * 100)
        : 0;

    const hasRealVariant =
      product?.variants?.length > 1 ||
      (product?.variants?.length === 1 &&
        firstVariant?.title !== "Default Title");

    return {
      item_id: product.id?.toString() || "NA",
      sku_id: firstVariant?.sku || "NA",
      item_name: product.title || "NA",
      index: startIndex + i,
      item_brand: "TVS Norton",
      item_category: collection.title || "NA",
      item_list_id: collection.handle || "NA",
      item_list_name: collection.title || "NA",
      item_variant: hasRealVariant ? firstVariant.title : "NA",
      price,
      quantity: 1,
      discount
    };
  });

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ ecommerce: null });

  window.dataLayer.push({
    event: "view_item_list_new",
    ecommerce: {
      item_list_id: collection.handle || "NA",
      item_list_name: collection.title || "NA",
      items
    }
  });

  window.__ga4SentCount = startIndex + visibleProducts.length;
};